module.exports = __webpack_public_path__ + "static/img/3.04a1ca3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/features_admin/3.png
// module id = PjOU
// module chunks = 0